module.exports = __webpack_public_path__ + "img/login_bg.92dc8468.png";